import { render, staticRenderFns } from "./AdminPlanList.vue?vue&type=template&id=61c46e5e"
import script from "./AdminPlanList.vue?vue&type=script&lang=js"
export * from "./AdminPlanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports